// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "html {\n  background-color: #f7f4e6;\n}", ""]);
// Exports
exports.locals = {
	"white": "#ffffff",
	"ecruWhite": "#f7f4e6",
	"soapstone": "#ece3da",
	"orangeWhite": "#e5e2ce",
	"albescent-white": "#e0dbca",
	"silverSand": "#bababa",
	"bonJour": "#e2e2e2",
	"domino": "#695b4d",
	"vanCleef": "#503c35",
	"jambalaya": "#624c37",
	"oliveHaze": "#8c7c64",
	"donkeyBrown": "#a39277",
	"bisonHide": "#b6a79a",
	"tiffanyBlue": "#00b6a9",
	"tiffanyBlueLight": "#13c3b2",
	"turqoise": "#4fe1d6",
	"robinEggBlue": "#00d2c2",
	"persianGreen": "#00a797",
	"frostedMint": "#e0fff7",
	"piggyPink": "#ffd8e2",
	"cinderella": "#f7d7c9",
	"cannonPink": "#893e5d",
	"geraldine": "#fd8093",
	"salmon": "#fca4b1",
	"lightPink": "#ffafbc",
	"azalea": "#fbbbc2",
	"pinkLace": "#ffcad2",
	"provincialPink": "#fff7f2",
	"chromeWhite": "#e6f0cf"
};
module.exports = exports;
